import Vue, { createApp } from "vue";
// import Vue, { createApp } from "@vue/compat";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { BootstrapVueIcons } from "bootstrap-vue";

import "./assets/css/main.scss";
import "./assets/main.css";

//  &^ ORG should be working
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "./assets/css/vue-sidebar-menu.css";

import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import { createPinia } from "pinia";

import App from "./PhysiciansConsole.vue";
import Console from "./Console.vue";

import router from "./router";

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask'


// & Font Awesome icons
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas, far);

// & vue3 MSAL plugin
import { msalPlugin, } from "vue3-msal-plugin";
import { msalInstance,  } from "@/config/authConfig";

import { setupAxiosInterceptors } from "./config/setupMSALAxios"


// ^ Console Application
// const app2 = createApp(Console);

// app2.mount('#app-two');


// & Physicians Console Application
// const app = createApp(App);
const app = createApp(Console);

app.component("font-awesome-icon", FontAwesomeIcon);
app.use(BootstrapVue);
app.use(BootstrapVueIcons);

app.use(router);

app.use(createPinia());

app.use(VueMask);
app.use(Vue3Toasity);

setupAxiosInterceptors();

// ^ Use the vue3-msal-plugin with the MSAL instance
app.use(msalPlugin, msalInstance);

router.isReady().then(async () => {
  const isDev = import.meta.env.VITE_TEST_VAR;
  const apiUrl = import.meta.env.VITE_REDIRECT_URI;
  const appName = import.meta.env.VITE_APP_NAME;

  const viteScopes = import.meta.env.VITE_SCOPES;

  app.mount("#app");
});


